import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Pagination} from 'src/app/domain/Pagination';
import {CatalogueService} from 'src/app/modules/services/catalogue/catalogue.service';
import {PaginatorComponent} from 'src/app/modules/widget/components/paginator/paginator.component';

@Component({
    selector: 'app-catalogue-p',
    templateUrl: './catalogue-p.component.html',
    styleUrls: ['./catalogue-p.component.css']
})
export class CataloguePComponent implements OnInit {
    @ViewChild(PaginatorComponent) p: PaginatorComponent;
    public data: any[] = [];
    public totalCount: number = 0;
    public type = null;

    public search = {
        'pagination': {
            'offSet': 0,
            'limit': 10
        },
        'sort': {
            'nameCol': 'prodNm',
            'direction': 'asc'
        },

        'dataSearch': null
    };

    constructor(private route: ActivatedRoute,
                private catalogueService: CatalogueService) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {

        this.catalogueService.loadData(this.search)
            .subscribe(response => {

                this.data = response['payload']['data'];


                this.totalCount = response['payload']['total'];

            });
    }

    onPaginate(pagination: Pagination) {

        this.search = {...this.search, pagination};
        this.loadData();
    }

    onSort(sort: any) {
        this.search = {...this.search, sort};
        this.loadData();
    }


    onSearch($event: Partial<any>) {
        this.search.dataSearch = $event;
        this.search.pagination.offSet = 0;
        this.search.pagination.limit = 10;
        this.loadData();
        this.p.paginator.pageIndex = 0;

    }

}
